"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoOnCallComponent = void 0;
var core_1 = require("@angular/core");
var fileSaver = require("file-saver");
var _services_1 = require("@/_services");
var NoOnCallComponent = /** @class */ (function () {
    function NoOnCallComponent(authenticationService) {
        this.authenticationService = authenticationService;
        this.callOnCall = function () {
            var url = this.get_gcdm_config['ON_CALL_hostname'];
            window.open(url, '_blank');
        };
        this.get_gcdm_config = this.authenticationService.get_config();
        this.get_brand = this.get_gcdm_config['brandUpperCase'];
        this.onCallContactNo = this.get_gcdm_config['on_call_contact_no'];
        this.loginBrand = this.get_gcdm_config['brand'];
    }
    NoOnCallComponent.prototype.saveFile = function (data, filename) {
        var blob = new Blob([data], { type: 'application/octet-stream' });
        fileSaver.saveAs(blob, filename);
    };
    NoOnCallComponent.prototype.ngOnInit = function () {
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], NoOnCallComponent.prototype, "childOnCall", void 0);
    NoOnCallComponent = __decorate([
        core_1.Component({
            selector: 'no-on-call',
            template: require('./nooncall.component.html')
        }),
        __metadata("design:paramtypes", [_services_1.AuthenticationService])
    ], NoOnCallComponent);
    return NoOnCallComponent;
}());
exports.NoOnCallComponent = NoOnCallComponent;
